import { type V1, v1 } from "backoffice-api"
import { t } from "i18next"
import { exists } from "utils"

const DEPARTMENT_SCOPE = "department"

type Department = V1["getDepartmentsBranch"][number]

type LeaderboardScope = {
  name: string
  value: string
}

export const getLeaderboardScopes = async (
  isGlobalLeaderboardEnabled: boolean
) => {
  const departments = await v1.getDepartmentsBranch()

  const scopes = flattenDepartments(departments).map(getScope)

  return [await getGlobalScope(isGlobalLeaderboardEnabled), ...scopes].filter(
    exists
  )
}

const flattenDepartments = (departments: Department[]): Department[] => {
  return departments.flatMap((department) => [
    department,
    ...flattenDepartments(department.children),
  ])
}

const getScope = (department: Department) => {
  const value = getScopeValue(department)

  if (value === undefined) return undefined

  return {
    name: department.name,
    value,
  } satisfies LeaderboardScope
}

const getGlobalScope = async (isGlobalLeaderboardEnabled: boolean) => {
  if (!isGlobalLeaderboardEnabled) return

  return {
    name: t("leaderboard.GLOBAL_SCOPE"),
    value: "company",
  } satisfies LeaderboardScope
}

const getScopeValue = ({ children, tags }: Department) => {
  const isLeafNode = children.length === 0

  if (!isLeafNode) return tags[0]

  return tags[0] ?? DEPARTMENT_SCOPE
}
